<div class="set-crew">
  <header class="set-crew-head">
    <h2 class="set-crew-title" [id]="titleId">Set crew</h2>
    <p class="set-crew-copy">{{ $description() }}</p>
  </header>

  <!-- Both crew fields, the Form host's Cancel / Apply footer, and the dirty gating on Apply. -->
  <wb-surface [definition]="$definition()" />
</div>
